module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0137.jpg?v=90e7109e";